import { PortStatus, PortSubmission } from "callable-data-objects";
import { CallableInput } from "Components/Shared";
import CallableDDIInput from "Components/Shared/CallableDDIInput";
import CallableDDITextArea from "Components/Shared/CallableDDITextArea";
import CarrierType from "Components/Shared/CarrierType";
import CNOSelect from "Components/Shared/CNOSelect";
import DateTimePicker from "Components/Shared/DateTimePicker";
import PortSubmissionType from "Components/Shared/PortSubmissionType";
import SubmissionStatusLabel from "Components/Shared/SubmissionStatusLabel";
import SubmissionStatusSelect from "Components/Shared/SubmissionStatusSelect";
import { Field, Formik } from "formik";
import useCheckRole from "Hooks/APICheckRole";
import { useTicket } from "Hooks/Endpoints";
import _ from "lodash";

import moment from "moment";
import React, { Fragment, useState } from "react";
import { useEffect } from "react";
import {
  Accordion,
  Button,
  Checkbox,
  Form,
  Icon,
  Label,
  Segment,
  Table,
} from "semantic-ui-react";
import * as yup from "yup";

const validation = yup.object().shape({
  portalRefNumber: yup.string().required(),
  lineType: yup.string().required(),
  mbn: yup.string().required(),
  associatedNumbers: yup.string(),
  rangeNumbers: yup.string(),
  originalPostalCode: yup.string().required(),
  postalCode: yup.string().required(),
  cno: yup.string().required(),
  rangeHolder: yup.string().required(),
  dueDate: yup.string().required(),
});

const statusValidation = yup.object().shape({
  dueDate: yup.string().required(),
  status: yup.string().required(),
  reason: yup.string().required(),
});

const PortSubmissionForm = () => {
  const { hasRole, roles } = useCheckRole();
  const {
    ticket,
    saveSubmission,
    saveSubmissionStatus,
    saveSubmissionStatusBulk,
  } = useTicket();
  const [openRow, setOpenRow] = useState<string[]>([]);
  const [checkedRow, setCheckedRow] = useState<string[]>([]);
  const [selectAllRows, setSelectAllRows] = useState<boolean>(false);
  const { submissions } = ticket.portRequest;
  const [showCreatePortSubmission, setShowCreatePortSubmission] =
    useState<boolean>(false);
  const [showSubmissions, setShowSubmissions] = useState<boolean>(true);

  useEffect(() => {
    console.log(selectAllRows);
    selectAllRows
      ? setCheckedRow(submissions.map((sub: PortSubmission) => sub.attempt))
      : setCheckedRow([]);
  }, [selectAllRows]);

  const getLastStatus = (statuses: PortStatus[]) => {
    if (statuses && statuses.length > 0)
      return statuses[statuses.length - 1].status;
    return "";
  };

  return (
    <Segment color='green'>
      {hasRole(roles.ticket.submissions.create) && (
        <Accordion styled fluid>
          <Accordion.Title
            active={showCreatePortSubmission}
            index={0}
            onClick={() =>
              setShowCreatePortSubmission(!showCreatePortSubmission)
            }
          >
            <Icon name='dropdown' />
            Create Submission
          </Accordion.Title>
          <Accordion.Content active={showCreatePortSubmission}>
            <Formik
              initialValues={{

              }}
              onSubmit={(values, actions) => {
                saveSubmission(values);
                setShowCreatePortSubmission(false);
                // actions.resetForm();
              }}
              validationSchema={validation}
              render={({ handleSubmit, isValid, errors }) => {
                return (
                  <Form onSubmit={handleSubmit}>
                    <h2>Add Submission</h2>

                    <DateTimePicker name='dueDate' label='Port Date' />

                    <CarrierType name='carrier' label='Target Carrier' />

                    <Field
                      name='portalRefNumber'
                      label='Portal Reference Number'
                      component={CallableInput}
                    />

                    <PortSubmissionType name='lineType' label='Line Type' />

                    <CNOSelect name='rangeHolder' label='Select Rangeholder' />

                    <CNOSelect name='cno' label='Select CNO' />

                    <Field
                      name='mbn'
                      label='Main Billing Number - (Textbox will auto format to E164)'
                      component={CallableDDIInput}
                    />

                    <Field
                      name='associatedNumbers'
                      label='Associated Numbers - (Textbox will auto format to E164)'
                      component={CallableDDITextArea}
                    />

                    <Field
                      name='rangeNumbers'
                      label='Associated Range - (Textbox will auto format to E164)'
                      component={CallableDDITextArea}
                    />

                    <Field
                      name='retainedNumbers'
                      label='Retained Numbers - (Textbox will auto format to E164)'
                      component={CallableDDITextArea}
                    />

                    <Field
                      name='originalPostalCode'
                      label='Original Postal Code'
                      component={CallableInput}
                    />

                    <Field
                      name='postalCode'
                      label='Postal Code'
                      component={CallableInput}
                    />

                    
                    <Button primary disabled={!isValid}>
                      Add Submission
                    </Button>
                  </Form>
                );
              }}
            />
          </Accordion.Content>
        </Accordion>
      )}
      {hasRole(roles.ticket.submissions.edit) && checkedRow.length > 0 && (
        <Segment>
          <Formik
            enableReinitialize={true}
            initialValues={{}}
            onSubmit={(values, actions) => {
              const subsToUpdate = submissions
                .filter(
                  (sub: PortSubmission) => checkedRow.indexOf(sub.attempt) > -1
                )
                .map((sub: PortSubmission) => sub.attempt);

              saveSubmissionStatusBulk(subsToUpdate, values);

              actions.resetForm();
            }}
            validationSchema={statusValidation}
            render={({ handleSubmit, isValid, errors }) => {
              return (
                <Segment>
                  <Form onSubmit={handleSubmit}>
                    <Form.Group widths='equal'>
                      <DateTimePicker name='dueDate' label='Port Date' />

                      <Field
                        name='reason'
                        label='Reason'
                        component={CallableInput}
                      />

                      <SubmissionStatusSelect name='status' label='Status' />

                      <Button
                        primary
                        disabled={!isValid}
                        style={{
                          marginTop: "23px",
                        }}
                      >
                        Update Statuses
                      </Button>
                    </Form.Group>
                  </Form>
                </Segment>
              );
            }}
          />
        </Segment>
      )}
      <Accordion styled fluid>
        <Accordion.Title
          active={showSubmissions}
          index={0}
          onClick={() => setShowSubmissions(!showSubmissions)}
        >
          <Icon name='dropdown' />
          View Submissions
        </Accordion.Title>
        <Accordion.Content active={showSubmissions}>
          <Table stackable compact>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>
                  <Checkbox
                    checked={selectAllRows}
                    onClick={() => setSelectAllRows(!selectAllRows)}
                  />
                </Table.HeaderCell>
                <Table.HeaderCell collapsing />
                {hasRole(roles.admin) && (
                  <Table.HeaderCell>Portal ref</Table.HeaderCell>
                )}
                <Table.HeaderCell>Line Type</Table.HeaderCell>
                <Table.HeaderCell>Postal From</Table.HeaderCell>
                <Table.HeaderCell>Postal To</Table.HeaderCell>
                {hasRole(roles.admin) && (
                  <Table.HeaderCell>Range Holder</Table.HeaderCell>
                )}
                <Table.HeaderCell>CNO</Table.HeaderCell>
                <Table.HeaderCell>MBN</Table.HeaderCell>
                <Table.HeaderCell>Associated</Table.HeaderCell>
                <Table.HeaderCell>Range</Table.HeaderCell>
                <Table.HeaderCell>CP Retain / Cease</Table.HeaderCell>
                <Table.HeaderCell>Due</Table.HeaderCell>
                <Table.HeaderCell>Status</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {submissions &&
                submissions.map((sub: PortSubmission) => (
                  <>
                    <Table.Row key={`sub${sub.attempt}`}>
                      <Table.Cell>
                        <Checkbox
                          checked={
                            checkedRow.find((s) => s === sub.attempt) !==
                            undefined
                          }
                          onClick={() =>
                            checkedRow.find((s) => s === sub.attempt) ===
                            undefined
                              ? setCheckedRow([...checkedRow, sub.attempt])
                              : setCheckedRow(
                                  checkedRow.filter((s) => s !== sub.attempt)
                                )
                          }
                        />
                      </Table.Cell>
                      <Table.Cell>
                        <Checkbox
                          slider
                          checked={
                            openRow.find((s) => s === sub.attempt) !== undefined
                          }
                          onClick={() =>
                            openRow.find((s) => s === sub.attempt) === undefined
                              ? setOpenRow([...openRow, sub.attempt])
                              : setOpenRow(
                                  openRow.filter((s) => s !== sub.attempt)
                                )
                          }
                        />
                      </Table.Cell>
                      {hasRole(roles.admin) && (
                        <Table.Cell>{sub.portalRefNumber}</Table.Cell>
                      )}
                      <Table.Cell>{sub.lineType}</Table.Cell>
                      <Table.Cell>{sub.originalPostalCode}</Table.Cell>
                      <Table.Cell>{sub.postalCode}</Table.Cell>
                      {hasRole(roles.admin) && (
                        <Table.Cell>{sub.rangeHolder}</Table.Cell>
                      )}
                      <Table.Cell>{sub.cno}</Table.Cell>
                      <Table.Cell>{sub.mbn}</Table.Cell>
                      <Table.Cell>{sub.associatedNumbers}</Table.Cell>
                      <Table.Cell>{sub.rangeNumbers}</Table.Cell>
                      <Table.Cell>{sub.retainedNumbers}</Table.Cell>
                      <Table.Cell>
                        {moment(sub.statuses.slice(-1)[0].dueDate).format(
                          "DD/MM/YYYY"
                        )}
                      </Table.Cell>
                      <Table.Cell>
                        <SubmissionStatusLabel
                          status={getLastStatus(sub.statuses)}
                        />
                      </Table.Cell>
                    </Table.Row>
                    {openRow.find((s) => s === sub.attempt) !== undefined && (
                      <Table.Row key={`subMore${sub.attempt}`}>
                        <Table.Cell colSpan='14'>
                          {hasRole(roles.ticket.submissions.edit) && (
                            <Formik
                              enableReinitialize={true}
                              initialValues={{
                                dueDate: sub.dueDate,
                              }}
                              onSubmit={(values, actions) => {
                                saveSubmissionStatus(sub.attempt, values);
                                actions.resetForm();
                              }}
                              validationSchema={statusValidation}
                              render={({ handleSubmit, isValid, errors }) => {
                                return (
                                  <Segment>
                                    <Form onSubmit={handleSubmit}>
                                      <Form.Group widths='equal'>
                                        <DateTimePicker
                                          name='dueDate'
                                          label='Port Date'
                                        />

                                        <Field
                                          name='reason'
                                          label='Reason'
                                          component={CallableInput}
                                        />

                                        <SubmissionStatusSelect
                                          name='status'
                                          label='Status'
                                        />

                                        <Button
                                          primary
                                          disabled={!isValid}
                                          style={{
                                            marginTop: "23px",
                                          }}
                                        >
                                          Update Status
                                        </Button>
                                      </Form.Group>
                                    </Form>
                                  </Segment>
                                );
                              }}
                            />
                          )}
                          <Table compact size='small' basic>
                            <Table.Header>
                              <Table.Row>
                                <Table.HeaderCell>Updated</Table.HeaderCell>
                                <Table.HeaderCell>Status</Table.HeaderCell>
                                <Table.HeaderCell>Description</Table.HeaderCell>
                                <Table.HeaderCell>Updated By</Table.HeaderCell>
                                <Table.HeaderCell>Due Date</Table.HeaderCell>
                              </Table.Row>
                            </Table.Header>
                            <Table.Body>
                              {sub.statuses.map((st: PortStatus) => (
                                <Table.Row key={`status${st.requested}`}>
                                  <Table.Cell>
                                    {moment(st.requested).format(
                                      "DD/MM/YYYY HH:mm"
                                    )}
                                  </Table.Cell>
                                  <Table.Cell>
                                    <SubmissionStatusLabel status={st.status} />
                                  </Table.Cell>
                                  <Table.Cell>{st.reason}</Table.Cell>
                                  <Table.Cell>{st.username}</Table.Cell>
                                  <Table.Cell>
                                    {moment(st.dueDate).format(
                                      "DD/MM/YYYY HH:mm"
                                    )}
                                  </Table.Cell>
                                </Table.Row>
                              ))}
                            </Table.Body>
                          </Table>
                        </Table.Cell>
                      </Table.Row>
                    )}
                  </>
                ))}
            </Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    </Segment>
  );
};

export default PortSubmissionForm;
